import React, {useCallback, useContext} from 'react'
import {WizardContext} from '../Wizard'
import {SET_REFERENCE_CONTENTS} from '../../WizardConstants'

export function WizardFormTextarea({data, form}) {
  const {dispatch} = useContext(WizardContext)
  const onChange = useCallback(
    (e) => {
      dispatch({type: SET_REFERENCE_CONTENTS, data: e.target.value})
    },
    [dispatch]
  )

  return (
    <div className='form-group'>
      <label style={{fontWeight: 'bold'}}>디자인설명</label>
      <span className='text-danger'> *필수입력사항*</span>
      <textarea
        className='form-control form-control-solid form-control-lg'
        name='img'
        placeholder='세부적인 디자인설명'
        rows='10' // 디자인 설명란이 너무 좁음 (2줄 -> 5줄 -> 10줄)
        defaultValue={form.req_text}
        onChange={onChange}
      />
      {/*<span className="form-text text-muted">Please enter your Address.</span>*/}
    </div>
  )
}
